import { FormikProps } from 'formik';
import {
  GiftCardDiscount,
  GiftCardProduct,
  GiftCardThemeType
} from 'services/api';

import { FormContainerProps } from '../Forms/FormContainer';
import { GiftCardPurchaseFormValues } from '../Forms/GiftCardPurchase/types';
import { OrderSummaryType } from './OrderSummary/types';

export enum GiftCardAction {
  Add = 'add',
  AddConfirm = 'add-confirm',
  View = 'view',
  CsvUpload = 'upload-csv',
  OrderConfirmation = 'order-confirmation',
  PaymentFlow = 'payment-flow',
  CsvUploadFailed = 'upload-csv-failed',
  DiscountFetchError = 'discount-fetch-error'
}

export type UploadSuccessStatus = {
  error: boolean;
  success: boolean;
};

export interface GiftCardPage
  extends Pick<
    FormContainerProps<GiftCardPurchaseFormValues>,
    'onSubmit' | 'buttons'
  > {
  config: Configuration | Record<string, never>;
  data: GiftCardProduct[];
  detailFormRef: React.RefObject<FormikProps<GiftCardPurchaseFormValues>>;
  enableSubmit: boolean;
  handleOrderSummaryChange: (changes: Record<string, string | number>) => void;
  handleSelectCard: (theme: GiftCardThemeType) => void;
  onActionClick: (action: GiftCardAction) => void;
  orderSummary: OrderSummaryType;
  selectedCard: GiftCardThemeType | null;
  toggleSubmit: (value: boolean) => void;
  csvRecipients:
    | {
        file: File | null;
        length: number;
      }
    | undefined;
  handleCsvUploadCancel: () => void;
  handleFormReset: () => void;
  tourSteps: any;
  runTour: boolean;
  resetTour: () => void;
  isLoading: boolean;
  placeOrderLoading: boolean;
  discount: { isLoading: boolean; data: GiftCardDiscount };
}
